export const MODEL_FAMILIES = {
  openai: { label: "OpenAI", color: "#10A37F", badgeBg: "#E8F5E9", badgeText: "#1B5E20", border: "#A5D6A7" },
  anthropic: { label: "Anthropic", color: "#D97757", badgeBg: "#FDF2E9", badgeText: "#7A3E1D", border: "#F5C6AA" },
  gemini: { label: "Google", color: "#1A73E8", badgeBg: "#E8F0FE", badgeText: "#174EA6", border: "#AECBFA" },
};

// Fallback catalog (backend /api/models is source of truth)
export const FALLBACK_MODELS = [
  { key: "gpt-5.6-terra", label: "GPT-5.6 Terra", family: "openai", tier: "pro" },
  { key: "gpt-5.6-luna", label: "GPT-5.6 Luna", family: "openai", tier: "pro" },
  { key: "gpt-5.4", label: "GPT-5.4", family: "openai", tier: "pro" },
  { key: "gpt-5.4-mini", label: "GPT-5.4 Mini", family: "openai", tier: "free" },
  { key: "gpt-5", label: "GPT-5", family: "openai", tier: "pro" },
  { key: "gpt-4.1", label: "GPT-4.1", family: "openai", tier: "pro" },
  { key: "gpt-4o", label: "GPT-4o", family: "openai", tier: "free" },
  { key: "o3", label: "OpenAI o3", family: "openai", tier: "pro" },
  { key: "claude-sonnet-4-6", label: "Claude Sonnet 4.6", family: "anthropic", tier: "pro" },
  { key: "claude-opus-4-6", label: "Claude Opus 4.6", family: "anthropic", tier: "pro" },
  { key: "claude-sonnet-4-5", label: "Claude Sonnet 4.5", family: "anthropic", tier: "pro" },
  { key: "claude-haiku-4-5", label: "Claude Haiku 4.5", family: "anthropic", tier: "free" },
  { key: "gemini-3.1-pro", label: "Gemini 3.1 Pro", family: "gemini", tier: "pro" },
  { key: "gemini-3-flash", label: "Gemini 3 Flash", family: "gemini", tier: "free" },
  { key: "gemini-2.5-pro", label: "Gemini 2.5 Pro", family: "gemini", tier: "pro" },
  { key: "gemini-2.5-flash", label: "Gemini 2.5 Flash", family: "gemini", tier: "free" },
];

export const DEFAULT_FREE_MODEL = "gpt-4o";

export const PRO_FEATURES = [
  "All 16 frontier models (GPT-5.6, Claude Opus, Gemini 3.1 Pro & more)",
  "Unlimited messages every day",
  "AI image generation studio",
  "Compare Mode — 3 models side by side",
  "Priority streaming responses",
];

export const PROMPT_PRESETS = [
  { title: "Coding assistant", prompt: "Help me debug and refactor this function for readability and performance." },
  { title: "Creative writing", prompt: "Write a short atmospheric story opening set in a rain-soaked city at dawn." },
  { title: "Data analysis", prompt: "Explain how to find correlations in a sales dataset and which charts to use." },
  { title: "Brainstorm ideas", prompt: "Give me 10 unconventional product ideas for a coffee subscription startup." },
];
